import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import './styles.css';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';
import strings from '../../../globalization';
import util from '../../../util';
import {getFormData} from './data';
import {editFormData} from './editData';
import DeletePopup from '../../../components/DeletePopup';
import PopupData from '../../../components/PopupPerson/popup';
import {operatorImages} from '../../../assets/images';

class PacksByPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: undefined,

      searchText: '',
      PacksByPass: [],
      filterPacksByPass: [],
      selectedStatus: '',
    };
  }
  statuses = [
    {
      id: '',
      name: 'ALL',
    },
    {
      id: 'inactive',
      name: 'INACTIVE',
    },
    {
      id: 'active',
      name: 'ACTIVE',
    },
  ];

  availabelPacks = [
    {
      id: 'Daily',
      name: 'Daily',
    },
    {
      id: 'Quaterly',
      name: 'Quaterly',
    },
    {
      id: 'Monthly',
      name: 'Monthly',
    },
    {
      id: 'Yearly',
      name: 'Yearly',
    },
  ];

  updatedStatus = this.statuses.filter(elem => elem.id !== '');
  onSubmit = PacksByPass => {
    const PacksByPassData = {
      name: PacksByPass.name.value,
      name_hindi: PacksByPass.name_hindi.value,
      packType: PacksByPass.packType.value,
      passCategoryId: PacksByPass.passCategoryId.value,
    };

    this.savePacksByPassCategory({
      ...PacksByPassData,
    });
    this.setState({
      popup: null,
    });
  };
  showErrorPopup = errorMsg => {
    // crashlytics().recordError(new Error(errorMsg));

    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},

        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.closePopup,
      },
    });
  };

  showSuccessPopup = (successMessage, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.onClose,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.onClose,
            outline: true,
          },
        ],
      },
    });
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'edit': {
        this.fetchPassCategoriesData(action, data);
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.EDIT_POPUP,
            categoryTypeData: data,
          },
        });

        break;
      }
      case 'delete': {
        data.status === 'ACTIVE' &&
          this.setState({
            PacksByPass: data,
            popup: {type: POPUP_CONSTANTS.DELETE_POPUP},
          });

        break;
      }
      default: {
        console.log('nahi match huya');
        break;
      }
    }
  };
  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  tableActionHandler = (action, data) => {
    switch (action) {
      case 'status': {
        console.info('data..', data);
        this.setState(
          {
            selectedStatus: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'shift': {
        break;
      }
      case 'add': {
        this.fetchPassCategoriesData(action, data);
        break;
      }
      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'clearFilter': {
        this.setState({
          searchText: '',
          selectedStatus: '',
        });
        this.fetchAllPacksByPassIdDataType();
        break;
      }
      default: {
        console.info('filterChangeHandler case not handled', action);
      }
    }
  };
  applyFilters = () => {
    const {searchText, selectedStatus, PacksByPass} = this.state;
    console.log('PacksByPass', PacksByPass);
    const filteredData =
      PacksByPass.length > 0 &&
      PacksByPass.filter(row => {
        // console.log('row', row);
        if (
          searchText &&
          !Object.values({
            name: row.name,
            name_hindi: row.name_hindi,
            packType: row.packType,
          })
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        ) {
          return false;
        }

        if (
          selectedStatus &&
          row.status.toLowerCase() !== selectedStatus.toLowerCase()
        ) {
          return false;
        }
        return true;
      });
    this.setState({
      filterPacksByPass: filteredData,
    });
  };
  fetchAllPacksByPassIdDataType = () => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.fetchAllPacksByPassIdData()
      .then(res => {
        let newResponse = res.data.map(elem => {
          let preparedNewElem = {};
          preparedNewElem['id'] = elem.id;
          preparedNewElem['name'] = elem.name;
          preparedNewElem['name_hindi'] = elem.name_hindi;
          preparedNewElem['packType'] = elem.packType;
          preparedNewElem['status'] = elem.status;
          preparedNewElem['passCategoryName'] =
            elem.passCategory && elem.passCategory.name;

          return preparedNewElem;
        });

        this.setState(
          {
            PacksByPass: newResponse,
            filterPacksByPass: newResponse,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };

  fetchPassCategoriesData = (action, data) => {
    API.fetchPassCategoriesData()
      .then(res => {
        console.log('resdata', res.data);
        let newResponse = res.data.filter(elem => elem.status !== 'INACTIVE');
        if (action === 'add') {
          this.setState({
            popup: {
              type: POPUP_CONSTANTS.ADD_DATA_POPUP,
              passCategories: newResponse,
              availabelPacks: this.availabelPacks,
            },
          });
        } else if (action === 'edit') {
          this.setState({
            popup: {
              type: POPUP_CONSTANTS.EDIT_POPUP,
              passCategories: newResponse,
              availabelPacks: this.availabelPacks,
              statuses: this.updatedStatus,
            },
          });
        }
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };

  savePacksByPassCategory = PacksByPassData => {
    let formData = {
      ...PacksByPassData,
      status: PacksByPassData.status,
    };

    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.savePacksByPassCategoryData(formData)
      .then(res => {
        this.showSuccessPopup(
          'PacksByPass Added Successfully',
          this.fetchAllPacksByPassIdDataType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  onDeleteHandler = () => {
    let id = this.state.PacksByPass.id;
    this.deletePacksByPassCategoryTypeData(id);
    this.setState({popup: null});
  };

  deletePacksByPassCategoryTypeData = id => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.deletePacksByPassCategoryData(id)
      .then(res => {
        this.showSuccessPopup(
          'PacksByPass Deleted Successfully',
          this.fetchAllPacksByPassIdDataType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  updatePacksByPassCategoryData = data => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.updatePacksByPassCategoryTypeData(data)
      .then(res => {
        this.showSuccessPopup(
          'PacksByPass Updated Successfully',
          this.fetchAllPacksByPassIdDataType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  onEditHandler = data => {
    console.log('data', data);
    let myData = {
      // id: this.state.PacksByPass.id,
      id: data.id.value,
      name: data.name.value,
      name_hindi: data.name_hindi.value,
      packType: data.packType.value,
      status: data.status.value.toUpperCase(),
      passCategoryId: data.passCategoryId.value,
    };

    this.updatePacksByPassCategoryData(myData);
    this.setState({popup: null});
  };
  getProps = () => {
    const {searchText, filterPacksByPass, selectedStatus} = this.state;
    return {
      onClick: this.onClickHandler,
      onChange: this.onChangeHandler,
      filterChangeHandler: this.tableActionHandler,
      PacksByPass: filterPacksByPass,
      statuses: this.statuses,
      searchText,
      selectedStatus,
    };
  };

  getPopupContent = () => {
    const {popup} = this.state;

    switch (popup.type) {
      case POPUP_CONSTANTS.ADD_DATA_POPUP: {
        return (
          <PopupData
            header="Add"
            onSubmit={this.onSubmit}
            onClose={this.onClose}
            getFormData={getFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.EDIT_POPUP: {
        return (
          <PopupData
            header="Edit"
            // categoryTypeData={this.state.PacksByPass} //FIXME add edited data
            onSubmit={this.onEditHandler}
            onClose={this.onClose}
            getFormData={editFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.DELETE_POPUP: {
        return (
          <DeletePopup onClick={this.onDeleteHandler} onClose={this.onClose} />
        );
      }

      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };
  componentDidMount() {
    this.fetchAllPacksByPassIdDataType();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

export default PacksByPass;
